import React, { FC } from 'react';
import classnames from 'classnames';
import { Asset, ArrowForwardIcon } from '@clearcover/atlas';

import styles from './styles.module.css';

type DirectionalCardProps = { className?: string };

export const DirectionalCard: FC<DirectionalCardProps> = ({
  className,
  children,
}) => {
  return (
    <div
      data-testid="directional-card"
      className={classnames(styles.card, className)}
    >
      {children}
      <div className={styles.icon}>
        <Asset
          className={styles.arrow}
          icon={ArrowForwardIcon}
          description="to"
          height={37}
          width={37}
        />
      </div>
    </div>
  );
};
